import { Card, Popover, Row, Button, Modal } from "antd";
import { keycloak } from "../../utils/keycloak";
import UserPreview from "../profile/UserPreview";
import "./RequestItemPreview.css";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react";
import { useState } from "react";
import { useMobxStores } from "../../stores/stores";
import { RequestListingApplicationModal } from "../RequestListingApplicationModal";

const RequestItemPreview = ({ request }) => {
  const [showApplicationModal, setShowApplicationModal] = useState(false);
  const { userStore } = useMobxStores();

  const navigate = useNavigate();

  const requireAuth = (onAuthenticated) => {
    if (keycloak.authenticated) {
      onAuthenticated();
    } else {
      Modal.confirm({
        title: "Sign in required",
        content:
          "You are not allowed to perform this action. You need to sign in first.",
        okText: "Sign in",
        cancelText: "Cancel",
        onOk: () => keycloak.login({ redirectUri: window.location.href }),
      });
    }
  };

  return (
    <>
      <Card
        onClick={() => {
          requireAuth(() => navigate(`${request.id}`));
        }}
        className="request-item-card"
        style={{}}
        title={
          <>
            <Row justify={"end"}>
              <Popover
                style={{ backgroundColor: "transparent" }}
                placement={"topLeft"}
                content={<UserPreview />}
              >
                <div
                  className="request-owner-name"
                  onMouseOver={() =>
                    userStore.GetUserDetails(request.poster_username)
                  }
                >
                  {request.poster_username}
                </div>
              </Popover>
            </Row>
            <Row>
              <div className="request-item-title">{request.title}</div>
            </Row>
            <Row justify={"end"}>
              <div className="request-item-type">{request.type}</div>
            </Row>
          </>
        }
        cover={
          <div>
            <div className="request-item-description">
              {request.description}
            </div>
          </div>
        }
      >
        <Button
          className="request-apply-button"
          type="primary"
          disabled={request.status.toLowerCase() === "completed"}
          onClick={(e) => {
            e.stopPropagation();
            requireAuth(() => setShowApplicationModal(true));
          }}
        >
          Apply
        </Button>
      </Card>
      <RequestListingApplicationModal
        showApplicationModal={showApplicationModal}
        setShowApplicationModal={setShowApplicationModal}
        requestId={request.id}
      />
    </>
  );
};

export default observer(RequestItemPreview);
